import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "skills-chart" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "skill-item" }
const _hoisted_4 = { class: "text-left skill-item-name" }
const _hoisted_5 = { class: "skill-chart-bar" }
const _hoisted_6 = { class: "skill-item-value" }
const _hoisted_7 = { class: "flex xs12" }
const _hoisted_8 = { class: "text-large font-weight-bold text-sm-start" }
const _hoisted_9 = { class: "text-left skill-item-name" }
const _hoisted_10 = { class: "skill-chart-bar" }
const _hoisted_11 = { class: "skill-item-value" }

import Skill from "../../models/skill"
import UserExam from "../../models/user_exam"
import SkillItem from "../../models/skill_item"

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'SkillsChart',
  props: {
    userExam: {},
    skills: {}
  },
  setup(__props: any) {

const props = __props

// Functions
function getSkillScore(skillItem: SkillItem): number {
  return Math.round(skillItem.getCurrentAverage(props.userExam) * 10) / 10
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.skills.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex xs12" }, [
            _createElementVNode("p", { class: "text-large font-weight-bold text-sm-start" }, "項目別平均")
          ], -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.skills, (skill, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "skill",
              key: index
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(skill.name), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: "skill-chart-progress",
                    style: _normalizeStyle({ width: skill.getSkillScore(__props.userExam) + '%' })
                  }, null, 4 /* STYLE */)
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(skill.getSkillScore(__props.userExam)) + "%", 1 /* TEXT */)
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    (__props.skills.length == 1)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.skills, (skill, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "skill",
            key: index
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(skill.name), 1 /* TEXT */)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skill.skillItems, (skillItem, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "skill-item",
                key: idx
              }, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(skillItem.name), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: "skill-chart-progress",
                    style: _normalizeStyle({ width: getSkillScore(skillItem) + '%' })
                  }, null, 4 /* STYLE */)
                ]),
                _createElementVNode("div", _hoisted_11, _toDisplayString(getSkillScore(skillItem)) + "%", 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})